import {get} from "lodash"
import BaseService from "./Base"
import {
    EditableRefund,
    FinAidRefund,
    FinAidRefundStats,
    PrefillFinAidRefundResult,
    ProgramType,
    TreatmentPeriod,
    TreatmentWorksheet,
    DisbursementWorksheet
} from "types/fin-aid/refund"

class FinAidRefundsService extends BaseService {
    list = async (params = {}): Promise<{total: number; data: FinAidRefund[]}> => {
        const response = await this.post(`/v1/fin-aid-refunds/list`, params)
        return get(response, "data", {total: 0, data: []})
    }

    getOne = async (refundId: number): Promise<FinAidRefund> => {
        const response = await this.get(`/v1/fin-aid-refunds/${refundId}`)
        return get(response, "data.data", {})
    }

    getStats = async (studentProfileId?: number): Promise<FinAidRefundStats> => {
        const query = studentProfileId != null ? `?studentProfileId=${studentProfileId}` : ""
        const response = await this.get(`/v1/fin-aid-refunds/stats${query}`)
        return get(response, "data.data", {
            pending: 0,
            requested: 0,
            refunded: 0,
            rejected: 0,
            total: 0
        })
    }

    create = async (
        data: EditableRefund & {
            studentProfileId: number
            runCalculate?: boolean
            usePrefill?: boolean
        }
    ): Promise<FinAidRefund> => {
        const response = await this.post(`/v1/fin-aid-refunds/create`, data)
        return get(response, "data.data", {})
    }

    edit = async (data: EditableRefund & {refundId: number; runCalculate?: boolean}): Promise<FinAidRefund> => {
        const response = await this.post(`/v1/fin-aid-refunds/edit`, data)
        return get(response, "data.data", {})
    }

    deleteRefunds = async (payload: {refundId?: number; refundIds?: number[]}): Promise<void> => {
        await this.post(`/v1/fin-aid-refunds/delete`, payload)
    }

    calculate = async (payload: {
        programType: ProgramType
        treatment: TreatmentWorksheet
        disbursement?: DisbursementWorksheet | null
    }): Promise<{treatment: TreatmentWorksheet; disbursement: DisbursementWorksheet}> => {
        const response = await this.post(`/v1/fin-aid-refunds/calculate`, payload)
        return get(response, "data.data", {})
    }

    prefill = async (payload: {
        studentProfileId: number
        termId?: number | null
        programType?: ProgramType | null
        period?: TreatmentPeriod | null
    }): Promise<PrefillFinAidRefundResult> => {
        const response = await this.post(`/v1/fin-aid-refunds/prefill`, payload)
        return get(response, "data.data", {})
    }
}

export default FinAidRefundsService
